<template>
    <div class="login">
        <div class="header">
            <div class="header-left"></div>
            <div class="header-center fl">
                <div class="header-title">实验线锂电池数字孪生系统</div>
                <div class="header-img"></div>
            </div>
            <div class="header-bottom fl"></div>
        </div>

        <div class="content">
            <div class="content-left">
                <!--<img src="images/d.png" alt="">-->
            </div>
            <div class="content-right">
                <el-form ref="loginFormRef" class="login-form" :model="loginForm" :rules="loginFormRules">
                    <!-- 用户名 -->
                    <el-form-item prop="userName" class="login-form-item">
                        <el-input v-model="loginForm.userName" class="login-form-input"></el-input>
                    </el-form-item>
                    <!-- 密码 -->
                    <el-form-item prop="userPassword" class="login-form-item">
                        <el-input v-model="loginForm.userPassword" type="password" class="login-form-input"></el-input>
                    </el-form-item>
                    <!-- 按钮区域 -->
                    <el-form-item label="" class="login-btn">
                        <el-button class="login-btn-item" @click="login">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
// import encrypt from "@/assets/js/encryptAES.js";
import { userQuery } from "@/assets/api/chartData";
export default {
    data() {
        return {
            loginForm: {
                userName: "",
                userPassword: "",
            },
             userInfo: {
        projectList: [],
        userAccess: 0,
        userCompany: "",
        userId: 0,
        userName: "",
        userPassword: "",
      },
            // 表单的验证规则对象
            loginFormRules: {
                // 验证用户名是否合法
                tUsername: [
                    { required: true, message: "请输入用户名", trigger: "blur" },
                    {
                        min: 3,
                        max: 10,
                        message: "长度在 3 到 10 个字符",
                        trigger: "blur",
                    },
                ],
                // 验证密码是否合法
                tUserpassword: [
                    { required: true, message: "请输入登陆密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 15,
                        message: "长度在 6 到 15 个字符",
                        trigger: "blur",
                    },
                ],
            },
            constants: {},
        };
    },
    methods: {
        login() {
            this.loginForm.userPassword = this.$Base64.encode(
                this.loginForm.userPassword
            );
            this.$refs.loginFormRef.validate(async (valid) => {
                if (valid) {
                    userQuery(this.loginForm).then((res) => {
                        var str = Math.random().toString(36).substring(2, 19);
                        if (res.code == "200") {
                            // token
                            sessionStorage.setItem("listInfo", JSON.stringify(str));
                            // 用户信息
                            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
                            this.$router.replace("/");
                        } else {
                            this.$message.error("账号或密码错误");
                        }
                    })
                }
            });
        },
    },
    mounted() {
        let thie = this;
        document.onkeydown = function (event) {
            var e = event || window.event || arguments.callee.caller.arguments[0];
            if (e && e.keyCode == 13) {
                // enter
                thie.login();
            }
        };
    },
};
</script>
  <style   src='./Login.css'/>
    
    
  </style>